import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'when_making_changes_contracts_does_facility_seek_written'

export const dataPointDefinition = {
  retracedId: 'when_making_changes_contracts_does_facility_seek_written',
  name: 'When making changes to contracts, does the facility seek the written agreement of the affected worker?',
  description:
    'The intent of this question is to understand if the facility is unilaterally making changes to the contract terms resulting in less favorable terms to the worker. ',
  meta: {
    slcpMeta: {
      key: 'rh-emp-13',
      number: 'RH-EMP-12',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-emp-13', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34420,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
